'use client';

import { createContext, ReactNode, useContext } from 'react';

// 밀당PT 리뉴얼: B2C(학생 웹)는 오류 화면을 DS FallbackPage로 그린다.
// 오류 화면 컴포넌트는 LMS·CMS·CRM과 함께 쓰므로, 학생 웹 루트에서만 켠다.
const FallbackPageContext = createContext(false);

export const FallbackPageProvider = ({ enabled, children }: { enabled: boolean; children: ReactNode }) => (
  <FallbackPageContext.Provider value={enabled}>{children}</FallbackPageContext.Provider>
);

export const useFallbackPageEnabled = () => useContext(FallbackPageContext);
